import { type FC, useContext } from 'react'
import { useIntl } from 'react-intl'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'
import { LoginRegistrationUserLoginShowPassword } from '../LoginRegistrationUserLoginForm/LoginRegistrationUserLoginShowPassword'

interface RegistrationFormPasswordInputProps {
  showPassword: boolean
  toggleShowPassword: () => void
}
export const LoginRegistrationRegistrationFormPasswordInput: FC<
  RegistrationFormPasswordInputProps
> = ({ showPassword, toggleShowPassword }) => {
  const intl = useIntl()
  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )
  const { model } = registrationFormState

  return (
    <FormControl
      error={!model.validator.isPropertyValid('password')}
      onChange={(event): void => {
        registrationFormState.setValue(event.target.value, model, 'password')
      }}
      value={model.password}
    >
      <FormLabel htmlFor="registerForm-password">
        {intl.formatMessage({ id: 'general.label.password' })}
        {`${intl.formatMessage({ id: 'general.label.passwordRequirements' })}*`}
      </FormLabel>
      <Input
        endAdornment={
          <LoginRegistrationUserLoginShowPassword
            showPassword={showPassword}
            toggleShowPassword={toggleShowPassword}
          />
        }
        id="registerForm-password"
        slotProps={{
          input: { 'data-qa-id': 'register-form-password' },
        }}
        type={showPassword ? 'text' : 'password'}
      />
      {model.validator.getFirstErrorFor('password') && (
        <FormHelperText>
          {model.validator.getFirstErrorFor('password')}
        </FormHelperText>
      )}
    </FormControl>
  )
}
